// avstemming-payroll-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'ave.c.gross': 'Gross salary',
  'ave.c.net': 'Net salary',
  'ave.c.withholding': 'Tax withholding',
  'ave.c.diff': 'Difference',
  'ave.c.status': 'Status',
  'ave.c.bank': 'Bank',
  'ave.c.amelding': 'A-melding',
  'ave.c.run': 'Run',
  'ave.c.employeeCount': 'Number of employees',
  'ave.c.openRun': 'Open run',
  'ave.c.none': 'None',
  'ave.c.seeRuns': 'View the payroll runs',
  'ave.c.requestDocs': 'Ask the client for documentation',
  'ave.c.close': 'Close',
  'ave.c.alert': 'Alert',
  'ave.c.assessment': 'Assessment',
  'ave.c.openCount': '{count} open',
  'ave.c.ofCount': '{done} of {total}',
  'ave.c.yes': 'Yes',
  'ave.c.no': 'No',
  'ave.c.missing': 'Missing',
  'ave.c.settled': 'Matches',
  'ave.c.employee': 'Employee',
  'ave.c.openAccount': 'Open account',
  'ave.page.noAccount': 'The payroll area has no reconciliation account to save the assessment on.',
  'ave.page.theRun': 'the run',
  'ave.page.secOverview': 'Overview',
  'ave.page.secRuns': 'Payroll runs',
  'ave.page.runsPosted': '{posted}/{total} posted',
  'ave.page.ameldingMissing': '{count} missing',
  'ave.page.secBank': 'Bank payments',
  'ave.page.secTax': 'Tax and employer contributions',
  'ave.page.openTerms': '{count} open terms',
  'ave.page.settledUp': 'Settled',
  'ave.page.secHoliday': 'Holiday pay and pension',
  'ave.page.secLines': 'Payroll lines',
  'ave.page.secDocs': 'Documentation',
  'ave.page.secControls': 'Review and approval',
  'ave.page.areaFallback': 'Payroll',
  'ave.page.hintUnassessed': '{count} payroll lines require assessment',
  'ave.page.title': 'Payroll — payroll system against general ledger, A-melding and bank',
  'ave.page.responsible': 'Responsible: {name}',
  'ave.page.intro': 'Payroll is reconciled against four sources, not a single balance. The comparison is the payroll runs\' own figures against the general ledger\'s own figures — the reconciliation does not recalculate salary, employer contributions or holiday pay.',
  'ave.page.restricted': 'Payroll data is restricted. The reconciliation shows employee names and amounts — not national ID numbers or bank account numbers. It does not need them to reach a conclusion.',
  'ave.page.txTitle': 'Review of employees and payroll lines',
  'ave.page.resetFilters': 'Reset filters',
  'ave.page.activeFilter': 'Active filter: {label}',
  'ave.page.lineCount': '{count} payroll lines',
  'ave.page.removeFilter': 'Remove filter',
  'ave.page.thEmployment': 'Employment',
  'ave.page.thRun': 'Payroll run',
  'ave.page.thChange': 'Change',
  'ave.page.assess': 'Assess',
  'ave.page.viewAssessment': 'View assessment',
  'ave.page.noMatch': 'No payroll lines match the filters.',
  'ave.page.noRuns': 'No posted payroll runs in this period. Without a payroll basis, payroll cannot be reconciled.',
  'ave.chk.derived.ameldingDiscrepancy': 'A-melding discrepancies have been handled',
  'ave.chk.derived.missingPayments': 'Missing payments have been investigated',
  'ave.chk.derived.duplicates': 'Possible duplicate payments have been assessed',
  'ave.chk.derived.negativeNet': 'Negative net salary has been assessed',
  'ave.chk.derived.unusualChange': 'Abnormal salary changes have been assessed',
  'ave.chk.derived.benefits': 'Benefits in kind have been checked',
  'ave.chk.derived.leaver': 'Pay to former employees has been explained',
  'ave.chk.derived.taxCard': 'Employees without a tax card have been followed up',
  'ave.chk.autoTitle': 'Automatic checks',
  'ave.chk.autoHint': 'The checks do not tick anything off in the professional checklist. They tell the person ticking items off what they should have looked at.',
  'ave.chk.thCheck': 'Check',
  'ave.chk.thResult': 'Result',
  'ave.chk.ran': 'Ran',
  'ave.chk.findings': '{count} findings',
  'ave.chk.noFindings': 'No findings',
  'ave.chk.listTitle': 'Professional checklist',
  'ave.chk.noPoints': 'No control points are defined for payroll in this period. The checklist follows the accounts in the area — add a payroll account to get the work programme.',
  'ave.chk.readOnlySuffix': '(the preparer\'s, read-only)',
  'ave.chk.scopeHint': 'The points apply to the whole payroll area. A tick is saved on all payroll accounts in the period.',
  'ave.chk.groupItems': 'Items requiring handling',
  'ave.chk.handled': '{done} of {total} handled',
  'ave.chk.notRelevant': 'Not applicable this period',
  'ave.chk.followsAssessments': 'Follows from the assessments',
  'ave.chk.groupAssessments': 'Overall professional assessments',
  'ave.chk.groupReady': 'Readiness',
  'ave.chk.performedBy': 'Performed by {name}',
  'ave.chk.progress': '{done} of {total} control points completed',
  'ave.chk.blk.linesOne': '{count} payroll line requires assessment',
  'ave.chk.blk.linesMany': '{count} payroll lines require assessment',
  'ave.chk.blk.mainOne': '{count} control area does not match between the sources',
  'ave.chk.blk.mainMany': '{count} control areas do not match between the sources',
  'ave.chk.blk.accountsOne': '{count} control account does not match the basis',
  'ave.chk.blk.accountsMany': '{count} control accounts do not match the basis',
  'ave.chk.blk.amelding': '{count} payroll runs are not registered as reported',
  'ave.chk.blk.bankOne': '{count} payroll run is not registered as paid out',
  'ave.chk.blk.bankMany': '{count} payroll runs are not registered as paid out',
  'ave.chk.blk.checklistOne': '{count} control point remains',
  'ave.chk.blk.checklistMany': '{count} control points remain',
  'ave.chk.conclTitle': 'Conclusion and approval',
  'ave.chk.conclLabel': 'Conclusion',
  'ave.chk.conclPlaceholder': 'What does the review of payroll show for this period?',
  'ave.chk.conclSavedAs': 'Saved as the justification on the control point “{label}”.',
  'ave.chk.risk': 'Remaining risk',
  'ave.chk.nothingLeft': 'Nothing remains that prevents the area from being sent for review.',
  'ave.chk.followUp': 'Follow-up next period',
  'ave.chk.noFollowUp': 'No assessments are marked for follow-up next period.',
  'ave.chk.followedUp': 'Follow up',
  'ave.chk.runGross': '{run} · {money} gross',
  'ave.chk.measure': 'Action: {measure}',
  'ave.chk.noMeasure': 'No action noted',
  'ave.chk.deadline': 'Deadline {date}',
  'ave.chk.openAssessment': 'Open assessment',
  'ave.chk.sendToReview': 'Send the area for review',
  'ave.chk.leftOne': 'One thing remains before the area can be sent.',
  'ave.chk.leftMany': '{count} things remain before the area can be sent.',
});
